/**
 * @public
 */
export var AutoTestPublishedSnapshotId;
(function (AutoTestPublishedSnapshotId) {
    AutoTestPublishedSnapshotId.visit = (value, visitor) => {
        if (value.unpublished !== undefined)
            return visitor.unpublished(value.unpublished);
        if (value.published !== undefined)
            return visitor.published(value.published);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestPublishedSnapshotId || (AutoTestPublishedSnapshotId = {}));
/**
 * @public
 */
export var AutoTestSetupStepOutput;
(function (AutoTestSetupStepOutput) {
    AutoTestSetupStepOutput.visit = (value, visitor) => {
        if (value.installDotnet !== undefined)
            return visitor.installDotnet(value.installDotnet);
        if (value.installJava !== undefined)
            return visitor.installJava(value.installJava);
        if (value.installPython !== undefined)
            return visitor.installPython(value.installPython);
        if (value.installNode !== undefined)
            return visitor.installNode(value.installNode);
        if (value.uploadFiles !== undefined)
            return visitor.uploadFiles(value.uploadFiles);
        if (value.installClang !== undefined)
            return visitor.installClang(value.installClang);
        if (value.installGcc !== undefined)
            return visitor.installGcc(value.installGcc);
        if (value.script !== undefined)
            return visitor.script(value.script);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestSetupStepOutput || (AutoTestSetupStepOutput = {}));
/**
 * @public
 */
export var AutoTestAutoInstallStepOutput;
(function (AutoTestAutoInstallStepOutput) {
    AutoTestAutoInstallStepOutput.visit = (value, visitor) => {
        if (value.autoInstallFlake8 !== undefined)
            return visitor.autoInstallFlake8(value.autoInstallFlake8);
        if (value.autoInstallPytest !== undefined)
            return visitor.autoInstallPytest(value.autoInstallPytest);
        if (value.autoInstallCodeStructureTest !== undefined)
            return visitor.autoInstallCodeStructureTest(value.autoInstallCodeStructureTest);
        if (value.autoInstallSimplePythonTest !== undefined)
            return visitor.autoInstallSimplePythonTest(value.autoInstallSimplePythonTest);
        if (value.autoInstallJupyterNotebook !== undefined)
            return visitor.autoInstallJupyterNotebook(value.autoInstallJupyterNotebook);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestAutoInstallStepOutput || (AutoTestAutoInstallStepOutput = {}));
/**
 * @public
 */
export var AutoTestSnapshotSource;
(function (AutoTestSnapshotSource) {
    AutoTestSnapshotSource.visit = (value, visitor) => {
        if (value.ran !== undefined)
            return visitor.ran(value.ran);
        if (value.copied !== undefined)
            return visitor.copied(value.copied);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestSnapshotSource || (AutoTestSnapshotSource = {}));
/**
 * @public
 */
export var BadRequestErrorReason;
(function (BadRequestErrorReason) {
    BadRequestErrorReason.visit = (value, visitor) => {
        if (value.wrongItemCount !== undefined)
            return visitor.wrongItemCount(value.wrongItemCount);
        if (value.unknownEnumType !== undefined)
            return visitor.unknownEnumType(value.unknownEnumType);
        if (value.invalidState !== undefined)
            return visitor.invalidState(value.invalidState);
        if (value.invalidParam !== undefined)
            return visitor.invalidParam(value.invalidParam);
        if (value.inexplicitRubricOverwrite !== undefined)
            return visitor.inexplicitRubricOverwrite(value.inexplicitRubricOverwrite);
        if (value.ignoreNonInteractedQuestions !== undefined)
            return visitor.ignoreNonInteractedQuestions(value.ignoreNonInteractedQuestions);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(BadRequestErrorReason || (BadRequestErrorReason = {}));
/**
 * @public
 */
export var AutoTestOverwriteRubric;
(function (AutoTestOverwriteRubric) {
    AutoTestOverwriteRubric.visit = (value, visitor) => {
        if (value.doOverwrite !== undefined)
            return visitor.doOverwrite(value.doOverwrite);
        if (value.doNotOverwrite !== undefined)
            return visitor.doNotOverwrite(value.doNotOverwrite);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestOverwriteRubric || (AutoTestOverwriteRubric = {}));
/**
 * @public
 */
export var AutoTestRedactedString;
(function (AutoTestRedactedString) {
    AutoTestRedactedString.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedString || (AutoTestRedactedString = {}));
/**
 * @public
 */
export var AutoTestRedactedDeductions;
(function (AutoTestRedactedDeductions) {
    AutoTestRedactedDeductions.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedDeductions || (AutoTestRedactedDeductions = {}));
/**
 * @public
 */
export var AutoTestRedactedCheckstyleVersion;
(function (AutoTestRedactedCheckstyleVersion) {
    AutoTestRedactedCheckstyleVersion.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedCheckstyleVersion || (AutoTestRedactedCheckstyleVersion = {}));
/**
 * @public
 */
export var AutoTestRedactedCodeStructureTestVersion;
(function (AutoTestRedactedCodeStructureTestVersion) {
    AutoTestRedactedCodeStructureTestVersion.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedCodeStructureTestVersion || (AutoTestRedactedCodeStructureTestVersion = {}));
/**
 * @public
 */
export var AutoTestRedactedInteger;
(function (AutoTestRedactedInteger) {
    AutoTestRedactedInteger.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedInteger || (AutoTestRedactedInteger = {}));
/**
 * @public
 */
export var AutoTestRedactedFlake8Version;
(function (AutoTestRedactedFlake8Version) {
    AutoTestRedactedFlake8Version.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedFlake8Version || (AutoTestRedactedFlake8Version = {}));
/**
 * @public
 */
export var AutoTestRedactedJunit5TestFile;
(function (AutoTestRedactedJunit5TestFile) {
    AutoTestRedactedJunit5TestFile.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedJunit5TestFile || (AutoTestRedactedJunit5TestFile = {}));
/**
 * @public
 */
export var AutoTestRedactedCaseSensitivity;
(function (AutoTestRedactedCaseSensitivity) {
    AutoTestRedactedCaseSensitivity.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedCaseSensitivity || (AutoTestRedactedCaseSensitivity = {}));
/**
 * @public
 */
export var AutoTestRedactedWhitespacesPolicy;
(function (AutoTestRedactedWhitespacesPolicy) {
    AutoTestRedactedWhitespacesPolicy.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedWhitespacesPolicy || (AutoTestRedactedWhitespacesPolicy = {}));
/**
 * @public
 */
export var AutoTestRedactedRunIfCondition;
(function (AutoTestRedactedRunIfCondition) {
    AutoTestRedactedRunIfCondition.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedRunIfCondition || (AutoTestRedactedRunIfCondition = {}));
/**
 * @public
 */
export var AutoTestRedactedRunInNotebookInsertMethod;
(function (AutoTestRedactedRunInNotebookInsertMethod) {
    AutoTestRedactedRunInNotebookInsertMethod.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedRunInNotebookInsertMethod || (AutoTestRedactedRunInNotebookInsertMethod = {}));
/**
 * @public
 */
export var AutoTestRedactedSelectAllQuestionAnswersValueHints;
(function (AutoTestRedactedSelectAllQuestionAnswersValueHints) {
    AutoTestRedactedSelectAllQuestionAnswersValueHints.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedSelectAllQuestionAnswersValueHints || (AutoTestRedactedSelectAllQuestionAnswersValueHints = {}));
/**
 * @public
 */
export var AutoTestRedactedBoolean;
(function (AutoTestRedactedBoolean) {
    AutoTestRedactedBoolean.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedBoolean || (AutoTestRedactedBoolean = {}));
/**
 * @public
 */
export var AutoTestRedactedPositiveDuration;
(function (AutoTestRedactedPositiveDuration) {
    AutoTestRedactedPositiveDuration.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedPositiveDuration || (AutoTestRedactedPositiveDuration = {}));
/**
 * @public
 */
export var AutoTestRedactedUploadedFilesOutput;
(function (AutoTestRedactedUploadedFilesOutput) {
    AutoTestRedactedUploadedFilesOutput.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedUploadedFilesOutput || (AutoTestRedactedUploadedFilesOutput = {}));
/**
 * @public
 */
export var AutoTestRedactedFraction;
(function (AutoTestRedactedFraction) {
    AutoTestRedactedFraction.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedFraction || (AutoTestRedactedFraction = {}));
/**
 * @public
 */
export var AutoTestSetupStepInput;
(function (AutoTestSetupStepInput) {
    AutoTestSetupStepInput.visit = (value, visitor) => {
        if (value.installDotnet !== undefined)
            return visitor.installDotnet(value.installDotnet);
        if (value.installJava !== undefined)
            return visitor.installJava(value.installJava);
        if (value.installPython !== undefined)
            return visitor.installPython(value.installPython);
        if (value.installNode !== undefined)
            return visitor.installNode(value.installNode);
        if (value.uploadFiles !== undefined)
            return visitor.uploadFiles(value.uploadFiles);
        if (value.installClang !== undefined)
            return visitor.installClang(value.installClang);
        if (value.installGcc !== undefined)
            return visitor.installGcc(value.installGcc);
        if (value.script !== undefined)
            return visitor.script(value.script);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestSetupStepInput || (AutoTestSetupStepInput = {}));
/**
 * @public
 */
export var AssistantMessageAssistantContent;
(function (AssistantMessageAssistantContent) {
    AssistantMessageAssistantContent.visit = (value, visitor) => {
        if (value.text !== undefined)
            return visitor.text(value.text);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageAssistantContent || (AssistantMessageAssistantContent = {}));
/**
 * @public
 */
export var AssistantMessageStopReason;
(function (AssistantMessageStopReason) {
    AssistantMessageStopReason.visit = (value, visitor) => {
        if (value.endTurn !== undefined)
            return visitor.endTurn(value.endTurn);
        if (value.maxTokens !== undefined)
            return visitor.maxTokens(value.maxTokens);
        if (value.guardRails !== undefined)
            return visitor.guardRails(value.guardRails);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageStopReason || (AssistantMessageStopReason = {}));
/**
 * @public
 */
export var User;
(function (User) {
    User.visit = (value, visitor) => {
        if (value.group !== undefined)
            return visitor.group(value.group);
        if (value.normal !== undefined)
            return visitor.normal(value.normal);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(User || (User = {}));
/**
 * @public
 */
export var AssistantMessageUserContent;
(function (AssistantMessageUserContent) {
    AssistantMessageUserContent.visit = (value, visitor) => {
        if (value.text !== undefined)
            return visitor.text(value.text);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageUserContent || (AssistantMessageUserContent = {}));
/**
 * @public
 */
export var AssistantMessageData;
(function (AssistantMessageData) {
    AssistantMessageData.visit = (value, visitor) => {
        if (value.user !== undefined)
            return visitor.user(value.user);
        if (value.assistant !== undefined)
            return visitor.assistant(value.assistant);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageData || (AssistantMessageData = {}));
/**
 * @public
 */
export var AssistantMessageContentBlock;
(function (AssistantMessageContentBlock) {
    AssistantMessageContentBlock.visit = (value, visitor) => {
        if (value.thinking !== undefined)
            return visitor.thinking(value.thinking);
        if (value.toolUse !== undefined)
            return visitor.toolUse(value.toolUse);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageContentBlock || (AssistantMessageContentBlock = {}));
/**
 * @public
 */
export var AssistantData;
(function (AssistantData) {
    AssistantData.visit = (value, visitor) => {
        if (value.assignment !== undefined)
            return visitor.assignment(value.assignment);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantData || (AssistantData = {}));
/**
 * @public
 */
export var AssistantStatus;
(function (AssistantStatus) {
    AssistantStatus.visit = (value, visitor) => {
        if (value.enabled !== undefined)
            return visitor.enabled(value.enabled);
        if (value.disabled !== undefined)
            return visitor.disabled(value.disabled);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantStatus || (AssistantStatus = {}));
/**
 * @public
 */
export var JupyterKernelStatus;
(function (JupyterKernelStatus) {
    JupyterKernelStatus.visit = (value, visitor) => {
        if (value.alive !== undefined)
            return visitor.alive(value.alive);
        if (value.dead !== undefined)
            return visitor.dead(value.dead);
        if (value.starting !== undefined)
            return visitor.starting(value.starting);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(JupyterKernelStatus || (JupyterKernelStatus = {}));
/**
 * @public
 */
export var JupyterMimeOutputDataEventValue;
(function (JupyterMimeOutputDataEventValue) {
    JupyterMimeOutputDataEventValue.visit = (value, visitor) => {
        if (value.inline !== undefined)
            return visitor.inline(value.inline);
        if (value.link !== undefined)
            return visitor.link(value.link);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(JupyterMimeOutputDataEventValue || (JupyterMimeOutputDataEventValue = {}));
/**
 * @public
 */
export var JupyterStreamOutputEventValue;
(function (JupyterStreamOutputEventValue) {
    JupyterStreamOutputEventValue.visit = (value, visitor) => {
        if (value.inline !== undefined)
            return visitor.inline(value.inline);
        if (value.link !== undefined)
            return visitor.link(value.link);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(JupyterStreamOutputEventValue || (JupyterStreamOutputEventValue = {}));
/**
 * @public
 */
export var JupyterOutputEvent;
(function (JupyterOutputEvent) {
    JupyterOutputEvent.visit = (value, visitor) => {
        if (value.executeStart !== undefined)
            return visitor.executeStart(value.executeStart);
        if (value.stream !== undefined)
            return visitor.stream(value.stream);
        if (value.displayData !== undefined)
            return visitor.displayData(value.displayData);
        if (value.executeResult !== undefined)
            return visitor.executeResult(value.executeResult);
        if (value.error !== undefined)
            return visitor.error(value.error);
        if (value.executeRequested !== undefined)
            return visitor.executeRequested(value.executeRequested);
        if (value.executeInterrupted !== undefined)
            return visitor.executeInterrupted(value.executeInterrupted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(JupyterOutputEvent || (JupyterOutputEvent = {}));
/**
 * @public
 */
export var EditorSessionSource;
(function (EditorSessionSource) {
    EditorSessionSource.visit = (value, visitor) => {
        if (value.template !== undefined)
            return visitor.template(value.template);
        if (value.submission !== undefined)
            return visitor.submission(value.submission);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(EditorSessionSource || (EditorSessionSource = {}));
/**
 * @public
 */
export var OuptutRegularFileType;
(function (OuptutRegularFileType) {
    OuptutRegularFileType.visit = (value, visitor) => {
        if (value.text !== undefined)
            return visitor.text(value.text);
        if (value.binary !== undefined)
            return visitor.binary(value.binary);
        if (value.quiz !== undefined)
            return visitor.quiz(value.quiz);
        if (value.notebook !== undefined)
            return visitor.notebook(value.notebook);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(OuptutRegularFileType || (OuptutRegularFileType = {}));
/**
 * @public
 */
export var InputFileType;
(function (InputFileType) {
    InputFileType.visit = (value, visitor) => {
        if (value.directory !== undefined)
            return visitor.directory(value.directory);
        if (value.regular !== undefined)
            return visitor.regular(value.regular);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(InputFileType || (InputFileType = {}));
/**
 * @public
 */
export var SafeProgramSource;
(function (SafeProgramSource) {
    SafeProgramSource.visit = (value, visitor) => {
        if (value.pearsonQuestion !== undefined)
            return visitor.pearsonQuestion(value.pearsonQuestion);
        if (value.singleQuizQuestion !== undefined)
            return visitor.singleQuizQuestion(value.singleQuizQuestion);
        if (value.submission !== undefined)
            return visitor.submission(value.submission);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(SafeProgramSource || (SafeProgramSource = {}));
/**
 * @public
 */
export var NumberOfAttempts;
(function (NumberOfAttempts) {
    NumberOfAttempts.visit = (value, visitor) => {
        if (value.unlimited !== undefined)
            return visitor.unlimited(value.unlimited);
        if (value.limited !== undefined)
            return visitor.limited(value.limited);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(NumberOfAttempts || (NumberOfAttempts = {}));
/**
 * @public
 */
export var PearsonQuestionData;
(function (PearsonQuestionData) {
    PearsonQuestionData.visit = (value, visitor) => {
        if (value.coding !== undefined)
            return visitor.coding(value.coding);
        if (value.multipleChoice !== undefined)
            return visitor.multipleChoice(value.multipleChoice);
        if (value.selectAll !== undefined)
            return visitor.selectAll(value.selectAll);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(PearsonQuestionData || (PearsonQuestionData = {}));
/**
 * @public
 */
export var PutPearsonQuestionSource;
(function (PutPearsonQuestionSource) {
    PutPearsonQuestionSource.visit = (value, visitor) => {
        if (value.coding !== undefined)
            return visitor.coding(value.coding);
        if (value.multipleChoice !== undefined)
            return visitor.multipleChoice(value.multipleChoice);
        if (value.selectAll !== undefined)
            return visitor.selectAll(value.selectAll);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(PutPearsonQuestionSource || (PutPearsonQuestionSource = {}));
/**
 * @public
 */
export var EditorFileType;
(function (EditorFileType) {
    EditorFileType.visit = (value, visitor) => {
        if (value.directory !== undefined)
            return visitor.directory(value.directory);
        if (value.regular !== undefined)
            return visitor.regular(value.regular);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(EditorFileType || (EditorFileType = {}));
/**
 * @public
 */
export var AutoTestRedactedTestStepOutput;
(function (AutoTestRedactedTestStepOutput) {
    AutoTestRedactedTestStepOutput.visit = (value, visitor) => {
        if (value.testHide !== undefined)
            return visitor.testHide(value.testHide);
        if (value.runIn !== undefined)
            return visitor.runIn(value.runIn);
        if (value.runIf !== undefined)
            return visitor.runIf(value.runIf);
        if (value.allowInternet !== undefined)
            return visitor.allowInternet(value.allowInternet);
        if (value.connectRubric !== undefined)
            return visitor.connectRubric(value.connectRubric);
        if (value.weight !== undefined)
            return visitor.weight(value.weight);
        if (value.checkstyle !== undefined)
            return visitor.checkstyle(value.checkstyle);
        if (value.javaCompile !== undefined)
            return visitor.javaCompile(value.javaCompile);
        if (value.junit5 !== undefined)
            return visitor.junit5(value.junit5);
        if (value.customTest !== undefined)
            return visitor.customTest(value.customTest);
        if (value.testTimeoutEach !== undefined)
            return visitor.testTimeoutEach(value.testTimeoutEach);
        if (value.flake8 !== undefined)
            return visitor.flake8(value.flake8);
        if (value.pytest !== undefined)
            return visitor.pytest(value.pytest);
        if (value.simplePythonTest !== undefined)
            return visitor.simplePythonTest(value.simplePythonTest);
        if (value.jupyterNotebook !== undefined)
            return visitor.jupyterNotebook(value.jupyterNotebook);
        if (value.runInNotebook !== undefined)
            return visitor.runInNotebook(value.runInNotebook);
        if (value.output !== undefined)
            return visitor.output(value.output);
        if (value.testUploadFiles !== undefined)
            return visitor.testUploadFiles(value.testUploadFiles);
        if (value.snapshot !== undefined)
            return visitor.snapshot(value.snapshot);
        if (value.ioTest !== undefined)
            return visitor.ioTest(value.ioTest);
        if (value.simpleMatch !== undefined)
            return visitor.simpleMatch(value.simpleMatch);
        if (value.regexMatch !== undefined)
            return visitor.regexMatch(value.regexMatch);
        if (value.substringMatch !== undefined)
            return visitor.substringMatch(value.substringMatch);
        if (value.codeStructureTest !== undefined)
            return visitor.codeStructureTest(value.codeStructureTest);
        if (value.negativeMatch !== undefined)
            return visitor.negativeMatch(value.negativeMatch);
        if (value.positiveMatch !== undefined)
            return visitor.positiveMatch(value.positiveMatch);
        if (value.quiz !== undefined)
            return visitor.quiz(value.quiz);
        if (value.codingQuestion !== undefined)
            return visitor.codingQuestion(value.codingQuestion);
        if (value.promptEngineeringQuestion !== undefined)
            return visitor.promptEngineeringQuestion(value.promptEngineeringQuestion);
        if (value.mcq !== undefined)
            return visitor.mcq(value.mcq);
        if (value.selectAllQuestion !== undefined)
            return visitor.selectAllQuestion(value.selectAllQuestion);
        if (value.program !== undefined)
            return visitor.program(value.program);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedTestStepOutput || (AutoTestRedactedTestStepOutput = {}));
